import { render } from "./image-column.vue?vue&type=template&id=759d8d4d&scoped=true"
import script from "./image-column.vue?vue&type=script&lang=js"
export * from "./image-column.vue?vue&type=script&lang=js"

import "./image-column.vue?vue&type=style&index=0&id=759d8d4d&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-759d8d4d"]])

export default __exports__